import { reducers } from '@wix/da-shared-react/pkg/redux/shared';
import profileHeroEditor from './profileHeroEditor';
import pagePrivileges from './pagePrivileges';
import profileOwner from './profileOwner';
import sections from './sections';
import gallectionSection from './gallectionSection';
import subscriptionsSection from './subscriptionsSection';
import layout from './layout';
import pageLayout from './pageLayout';
import pageInfo from './pageInfo';
import modules from './modules';
import statsSection from './statsSection';
import avatarEditor from './avatar';
import profileSkins from './profileSkins';

const DEFAULT_ENVIRONMENT = {};

const rootReducers = {
  ...reducers,
  profileHeroEditor,
  pagePrivileges,
  profileOwner,
  sections,
  gallectionSection,
  subscriptionsSection,
  environment: state => state || DEFAULT_ENVIRONMENT,
  layout,
  pageLayout,
  pageInfo,
  modules,
  statsSection,
  avatarEditor,
  profileSkins,
};

export default rootReducers;
